<template>
  <div class="PageBox">
    <div class="ScrollBox">
		<van-nav-bar
		  fixed
		  :border="false"
		  title="Detail proyek"
		  left-arrow
		  @click-left="$router.go(-1)">
		</van-nav-bar>
	  <div class="root">
		  <div class="dapp">
			  <div class="product">
				  <div class="thumb">
					  <div class="act">
						  <span class="tit">{{$t('product.default[0]')}}</span>
						  <span class="val">{{Number(UserInfo.balance)}}</span>
					  </div>
					  <div class="img">
					  </div>
				  </div>
				  <div class="infos">
					<li class="inf">
						  <span class="tit">{{$t('product.investRange')}}</span> : 
						  <span class="val">{{productinfo.min_money}}-{{productinfo.max_money}}</span>
					 </li>
					  <li class="inf">
					  	  <span class="tit">{{$t('product.default[3]')}}</span> : 
					  	  <span class="val">{{productinfo.time}} {{$t("userLc.default[11]")}}</span>
					   </li>
					   <li class="inf">
					   	  <span class="tit">{{$t('product.default[4]')}}</span> : 
					   	  <span class="val">{{productinfo.lilv}} %</span>
					    </li>
				  </div>
				  <div class="submit">
					<div class="input">
						<input type="number" maxlength="8"  :placeholder='$t("userLc.default[5]")' v-model="money" class="input-wrapper">
						<span @click="all_in">{{$t('product.default[5]')}}</span>
					</div>
					<!-- <div class="input">
						<input type="text" :placeholder='$t("product.placeholder[3]")' v-model="drawword" class="input-wrapper">
					</div> -->
					<div class="earning">{{all}}</div>
					<div @click="sub" class="button">{{$t("userLc.default[7]")}}</div>
				  </div>
				  <div class="content">
					  <div class="tit">
						  {{$t('product.default[6]')}}
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[7]')}}:</span>
						  <span>{{productinfo.project_amount}} {{InitData.currency}}</span>
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[8]')}}:</span>
						  <span>{{$t('product.placeholder[0]')}}</span>
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[9]')}}:</span>
						  <span>{{productinfo.min_money}} {{InitData.currency}}</span>
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[10]')}}:</span>
						  <span>{{productinfo.lilv}} %</span>
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[11]')}}:</span>
						  <span>{{productinfo.time}} {{$t("userLc.default[11]")}}{{$t('product.placeholder[1]')}}</span>
					  </div>
					  <div class="col">
						  <span>{{$t('product.default[12]')}}:</span>
						  <span>{{$t('product.placeholder[2]',{str:this.str,income:this.income,currency:InitData.currency,money:this.money,total:this.total})}}</span>
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  components: {
  },
  props: [],
  data() {
    return {
		productinfo: [],
		money:'',
		all:'',
		msg:'',
		productId:'',
		str:'',
		income:'',
		total:'',
		drawword:''
    }
  },
  computed: {

  },
  watch: {
    money(){
		let str = this.money + ' + (' + this.money +' * ' + (this.productinfo.lilv/100).toFixed(3) +' * ' + this.productinfo.time + ') = ';
		let income = (parseFloat(this.money) + this.money * (this.productinfo.lilv/100).toFixed(3) * this.productinfo.time).toFixed(3);
		return this.all = str + income;
    }
  },
  created() {
	  this.productId = this.$route.params.productId;
	  this.$Model.GetUserInfo();
	  this.getYuebaoinfo();
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
	  getYuebaoinfo() {
	    this.$Model.GetYuebaoinfo(this.productId,data=>{
	      this.isLoad = false
	      if(data.code==1){
			  this.productinfo = data.info;
			  this.money = this.productinfo.min_money;
			  
			  this.str = this.productinfo.min_money +' * ' + this.productinfo.lilv +'% * ' + this.productinfo.time + ' ' + this.$t("userLc.default[11]");
			  this.income = parseFloat(this.productinfo.min_money * parseFloat(this.productinfo.lilv/100) * this.productinfo.time).toFixed(2);
			  this.total = (parseFloat(this.productinfo.min_money) + parseFloat(this.income)).toFixed(3);
	      }
	    })
	  },
	  all_in(){
		  this.money = this.UserInfo.balance;
		  //if(this.UserInfo.balance < this.productinfo.max_money)this.money = this.UserInfo.balance;
		  //if(this.UserInfo.balance >= this.productinfo.max_money)this.money = this.productinfo.max_money;
	  },
	  sub(){
	     if(this.money == ''){
	        this.$Dialog.Toast(this.$t("userLc.default[9]"));
	        return
	     }
		 // if (!this.drawword) {
		 //   this.$Dialog.Toast(this.$t("wallet.placeholder[2]"));
		 //   return;
		 // }
	     let obj = {
	        userid:JSON.parse(localStorage.getItem("UserInfo")).userid,
	        yuebaoid : this.productinfo.id,
	        money :this.money,
			drawword:this.drawword
	     }
	      this.$Model.newLcTj(obj,data=>{
	          if(data.errorCode == 200){
	            this.$Dialog.Toast(data.successMsg);
	            this.money = ''
	            this.$router.push(`/user/newLc`)
	            return
	          }
	          this.$Dialog.Toast(data.errorMsg);
	      })
	  },
  }
}
</script>
<style scoped>
.root {
    position: relative;
    flex: 1 0 auto;
    background: #fafafa;
}
.dapp {
    position: relative;
    max-width: 720px;
    margin: auto;
    background-color: #fff;
}
.dapp .product {
    display: block;
    padding: 17px;
}
.dapp .product .thumb {
    display: block;
    height: 88px;
    background: #37774C;
    border-radius: 8px;
    position: relative;
}
.dapp .product .thumb .act {
    padding: 27px 0 0 15px;
    color: #fff;
    font-size: 14px;
}
.dapp .product .thumb .act .tit {
	display: block;
}
.dapp .product .thumb .act .val {
    font-size: 19px;
    font-weight: 500;
    padding-top: 6px;
}
.dapp .product .thumb .img {
    position: absolute;
    right: 0;
    top: 16px;
    right: 11px;
    width: 85px;
    bottom: 16px;
	background-image: url(/static/images/invest_bg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.dapp .product .infos .inf {
    display: flex;
    justify-content: space-between;
    padding: 17px 0;
    font-size: 14px;
    border-bottom: 1px solid hsla(0,0%,78.4%,.35);
}
.dapp .product .infos .tit {
    color: #666;
}
.dapp .product .infos .val {
    font-weight: 500;
    font-size: 15px;
	color: #666;
}
.dapp .product .submit {
    background: #fffcf5;
    border-radius: 8px;
    padding: 17px;
    position: relative;
}
.dapp .product .submit .input {
    position: relative;
    height: 36px;
    background: #fff;
    margin-bottom: 17px;
    border: 1px solid #ddd;
    border-radius: 18px;
    overflow: hidden;
}
.dapp .product .submit .input .input-wrapper {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
	text-indent: inherit;
	padding-left: 15px;
	border: none;
	color: #333;
}
.dapp .product .submit .input span {
    position: absolute;
    right: -1px;
    top: -1px;
    font-size: 15px;
    font-weight: 500;
    height: 36px;
    line-height: 36px;
    padding: 0 17px;
    background: #37774C;
    color: #fff;
    border-radius: 0 18px 18px 0;
}
.dapp .product .submit .earning {
    text-align: right;
    color: #991d35;
    font-size: 14px;
}
.dapp .product .submit .button {
    margin-top: 17px;
	position: relative;
	display: block;
	margin-left: auto;
	margin-right: auto;
	padding-left: 14px;
	padding-right: 14px;
	box-sizing: border-box;
	text-align: center;
	text-decoration: none;
	line-height: 2.55555556;
	border-radius: 5px;
	-webkit-tap-highlight-color: transparent;
	overflow: hidden;
	background-color: #f8f8f8;
	cursor: pointer;
	height: 46px;
	border-radius: 42px;
	background: #37774C;
	color: #fff;
	font-weight: 500;
	font-size: 17px;
	transition: opacity .2s ease 0s;
	cursor: pointer;
}
.dapp .product .content {
    padding: 17px 0;
    font-size: 14px;
}
.dapp .product .content .tit {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #37774C;
    font-weight: 700;
    font-size: 17px;
    color: #37774C;
}
.dapp .product .content .col {
    display: flex;
    justify-content: space-between;
    padding: 13px 0;
    border-bottom: 1px solid #f0f0f0;
    line-height: 1.25;
}
.dapp .product .content .col>span {
    color: #333;
}
.dapp .product .content .col>span:first-child {
    min-width: 50%;
}
</style>